/**
 * @type {import('i18next').InitOptions}
 */
export default {
  supportedLngs: ["en", "ar"],
  fallbackLng: "en",
  defaultNS: "translation",
  keySeparator: false,
};
